import React from "react"

import { withTestimonialsItem } from "./withTestimonialsItem"
import { Icon } from "../../../Icon/Icon"
import { StyledContainer } from "../../../Styled/Container"
import { Item, Column, Quote } from "../TestimonialsStyles"
import { Small } from "../../../Styled/Text"

export const TestimonialsItem = withTestimonialsItem(
  ({ item }): JSX.Element => (
    <StyledContainer width={`xl`}>
      <Item items={`center`} withWrap={`<sm`}>
        <Column width={`md:1/2`} />
        <Column width={`md:1/2`}>
          <Icon name={`quote`} width={45} />
          {item?.quote && (
            <Quote colour={`white`} italic large>
              {item?.quote}
            </Quote>
          )}
          {(item?.name || item?.location) && (
            <Small colour={`white`} large>
              {item?.name && <strong>{item.name}</strong>}
              {item?.name && item?.location && `,`}
              {item?.location && ` ${item.location}`}
            </Small>
          )}
        </Column>
      </Item>
    </StyledContainer>
  )
)
